// نصوص المكوّنات الأساسية المشتركة (المؤشر المرحلي، القوائم المنسدلة، حقول النطاق).
// انظر src/components/base/. النسخة الإنجليزية في en/ui.ts ويجب أن تطابقها في المفاتيح.
// الأرقام تُكتب بالأرقام الغربية (1، 2، 3) كما في بقية الموقع.
const ui = {
  stepper: {
    label: 'خطوات العملية',
    counter: 'الخطوة {{current}} من {{total}}',
    counterWithLabel: 'الخطوة {{current}} من {{total}}: {{label}}',
    stepWithLabel: 'الخطوة {{n}}: {{label}}، {{status}}',
    stepNoLabel: 'الخطوة {{n}}، {{status}}',
    status: {
      completed: 'مكتملة',
      current: 'الحالية',
      upcoming: 'قادمة',
    },
    goTo: 'العودة إلى الخطوة {{n}}: {{label}}',
    goToNoLabel: 'العودة إلى الخطوة {{n}}',
  },
  combobox: {
    noResults: 'لا توجد نتائج مطابقة',
    loading: 'جارٍ التحميل…',
    clear: 'مسح',
    suggestions: 'اقتراحات',
  },
  select: {
    placeholder: 'اختر',
  },
  range: {
    from: 'من',
    to: 'إلى',
    any: 'الكل',
    price: 'السعر',
    priceYearly: 'السعر (سنوياً)',
    area: 'المساحة',
    unitSqm: 'م²',
    minGreaterThanMax: 'الحد الأدنى أكبر من الحد الأقصى',
    chooseTypeHint: 'اختر نوع العقار لعرض غرف النوم ودورات المياه',
    customAmount: 'أو اكتب مبلغاً',
    // مكوّنات البحث (src/components/search/): اسم الحقل لقارئ الشاشة، مثل «غرف النوم: من».
    boundLabel: '{{field}}: {{bound}}',
    customNumber: 'أو اكتب رقماً',
    priceMonthly: 'السعر (شهرياً)',
    // The شهري / سنوي toggle on the rent price column.
    period: {
      label: 'فترة الإيجار',
      monthly: 'شهري',
      yearly: 'سنوي',
    },
  },
  // قائمة المدن (CityCombobox).
  city: {
    label: 'المدينة',
    allCities: 'كل المدن',
    placeholder: 'اختر المدينة',
  },
  // منتقي نوع العقار (PropertyTypePicker).
  typePicker: {
    label: 'نوع العقار',
    anyType: 'كل الأنواع',
    showMore: 'عرض المزيد ({{count}})',
    showLess: 'عرض أقل',
  },
};

export default ui;
